var play_icon_default = {
  "shadow": "F1PIr",
  "playIcon": "_13CQ2"
};
export {
  play_icon_default as default
};
//# sourceMappingURL=play-icon-scss.js.map
